import { Messages } from '../../../../codegen/Localize';
import { IGroupInfo } from '../../../../ts/models/IGroupInfo';
import { deleteGroups } from '../../../actions/spaces/GroupMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const GroupDeleteAction: IEntityAction<IGroupInfo, {}> = {
  name: EntityActionNames.DeleteGroup,
  translateName: Messages.deleteGroup_action,
  isVisible: (targetItems: IGroupInfo[], state: AppState) => {
    const targetItemsWithoutAllUsersGroup = targetItems.filter(group => !group.isAllUsersGroup);
    return targetItemsWithoutAllUsersGroup.length >= 1;
  },
  isClickable: () => true,
  createReduxAction: (targetItems: IGroupInfo[]) => deleteGroups(targetItems)
};
